export default function PHP_extract() {
  return (
    <div>
      <h1>PHP_extract</h1>
    </div>
  );
}
